/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Changes_1Inputs */

const da_privacy_changes_1 = /** @type {(inputs: Privacy_Changes_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ændrer vi politikken væsentligt, giver vi besked i appen eller på e-mail.`)
};

/** @type {(inputs: Privacy_Changes_1Inputs) => LocalizedString} */
const en_privacy_changes_1 = da_privacy_changes_1;

/**

* @param {Privacy_Changes_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_changes_1 = /** @type {((inputs?: Privacy_Changes_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Changes_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_changes_1(inputs)
	return /** @type {LocalizedString} */ ("Ændrer vi politikken væsentligt, giver vi besked i appen eller på e-mail.")
});